import { ConceptsDeductionsRow } from "./columnsConceptsDeductions";
import { DetailPaymentPackageItem } from "shared/api/services";

export const mapDetailPaymentPackageToConceptsDeductions = (
  items: DetailPaymentPackageItem[],
): ConceptsDeductionsRow[] => {
  const mappedItems = items.map((item, index) => ({
    id: item.id,
    rowId: index.toString(),
    codigoIdentificador: item.consecutive,
    codigoConcepto: item.conceptCode,
    concepto: item.conceptName,
    nitAcreedor: item.employerIdNumber,
    acreedor: item.employerName,
    valor: item.totalValue,
    signo: item.operatingIndicator,
    codigoCentroCostos: item.costCenterCode,
    nombreCentroCostos: item.conceptName,
    certificadoPresupuestal: item.budgetCertificate,
    rcp: item.budgetRegistration,
    codigoMaterial: "1001665",
  }));

  return mappedItems.sort((a, b) => {
    if (a.signo === "+" && b.signo === "-") return -1;
    if (a.signo === "-" && b.signo === "+") return 1;
    return 0;
  });
};
